import { SvgIcon, SvgIconProps } from "@mui/material";

export const RemoveKeyPointIcon = (props: SvgIconProps) => {
	return (
		<SvgIcon viewBox="0 0 10 10" {...props}>
			<g clip-path="url(#clip0_10271_22897)">
				<path
					d="M4.99488 9.08938C7.25567 9.08938 9.0884 7.25665 9.0884 4.99586C9.0884 2.73507 7.25567 0.902344 4.99488 0.902344C2.7341 0.902344 0.901367 2.73507 0.901367 4.99586C0.901367 7.25665 2.7341 9.08938 4.99488 9.08938Z"
					stroke="#FAFAFA"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M3.46875 5.12012H6.46875"
					stroke="#FAFAFA"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_10271_22897">
					<rect width="9.99109" height="9.99109" fill="white" />
				</clipPath>
			</defs>
		</SvgIcon>
	);
};
